import { USER_PREFERENCES } from 'constants/index'
import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'
import { isEmpty } from 'lodash'

type Preferences = {
  lastSelectedAssets: boolean
  socialFeedPanel: boolean
  defaultLvgGraphId: string
  emailIfBidPlaced: boolean
  emailIfOrderBusted: boolean
  emailIfRoiChange5: boolean
}

/**
 * Preferences Atom
 */
export const PREFERENCES_INIT: Preferences = {
  lastSelectedAssets: true,
  socialFeedPanel: true,
  defaultLvgGraphId: '0',
  emailIfBidPlaced: true,
  emailIfOrderBusted: true,
  emailIfRoiChange5: true,
}
export const userPreferencesAtom = atomWithStorage(USER_PREFERENCES, PREFERENCES_INIT)
export const updateUserPreferencesAtom = atom(null, async (get, set, payload: Partial<Preferences> | undefined) => {
  if (isEmpty(payload)) {
  } else set(userPreferencesAtom, (prev) => ({ ...prev, ...payload }))
})
